<template>
    <Card :title="$t('scopeTitle')" class="mt-3 flex w-full flex-col gap-2 ">
        <div id="risk-scope-card">
            <div v-if="showDbData.ip5.length" class="rounded-lg border border-grey-40 px-6 pb-5 pt-3 ">
                <p class="mb-3 text-sm leading-6 text-eureka-600">{{$t('ip5')}}</p>
                <div class="flex flex-wrap">
                    <Country v-for="(item, index) in showDbData.ip5" :key="index" :country-code="item" class="w-1/5"/>
                    <span class="text-sm text-gray-90" v-if="restCount.ip5">
                        + {{ restCount.ip5 }}
                    </span>
                </div>
            </div>
            <div v-if="showDbData.major.length" class="mt-2 rounded-lg border border-grey-40 px-6 pb-5 pt-3">
                <p class="mb-3 text-sm leading-6 text-eureka-600">{{ $t('major') }} </p>
                <div class="flex flex-wrap">
                    <Country v-for="(item, index) in showDbData.major" :key="index" :country-code="item" class="w-1/5"/>
                    <span class="text-sm text-gray-90" v-if="restCount.major">
                        + {{ restCount.major }}
                    </span>
                </div>
            </div>
            <div v-if="showDbData.others.length" class="mt-2 rounded-lg border border-grey-40 px-6 pb-5 pt-3 ">
                <p class="mb-3 text-sm leading-6 text-eureka-600">{{ $t('others') }} </p>
                <div class="flex flex-wrap">
                    <Country v-for="(item, index) in showDbData.others" :key="index" :country-code="item" class="w-1/5"/>
                    <span class="text-sm text-gray-90" v-if="restCount.others">
                        + {{ restCount.others }}
                    </span>
                </div>
            </div>
        </div>
    </Card>
</template>
<script setup lang="ts">
import { useGlobalState } from '@/composables/use-global-store';
import Card from '../Card.vue';
import { onMounted, ref } from 'vue';
import { cloneDeep, get, set, slice } from 'lodash';
import { Country, dbConfigDeferred } from '@eureka/shared/country-select'

const showCountryCounts = 10;
const { country } = useGlobalState();
const originDbConfig = ref()

const showDbData = ref({
    ip5: [],
    major: [],
    others: [],
})

const restCount = ref({
    ip5: 0,
    major: 0,
    others: 0,
})

onMounted(async() => {
    const data = await dbConfigDeferred.promise
    originDbConfig.value = cloneDeep(data.patentCountries)
    for (const key in originDbConfig.value) {
        const selectedDbData = {}
        set(selectedDbData, key, get(originDbConfig.value, key).filter((o:string) => country.value?.includes(o)))
        const checked = get(selectedDbData, key)
        if (checked.length > showCountryCounts) {
            set(showDbData.value, key, slice(checked, 0, showCountryCounts))
            set(restCount.value, key, checked.length - showCountryCounts)
        } else {
            set(showDbData.value, key, checked)
        }
    }
})

</script>
